<app-dialog [title]="'popups.feedback.title' | transloco">
  <form ngProjectAs="dialog-body" [formGroup]="form" class="text-sm text-secondary">
    <div>
      <div class="field">
        <ng-select [placeholder]="'popups.feedback.type' | transloco"
                   formControlName="type"
        >
          <ng-option *ngFor="let type of types"
                     [value]="type">{{ 'popups.feedback.types.' + type | transloco }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="mt-3">
      <div>
        <app-textarea formControlName="description"
                      [placeholder]="'popups.feedback.description' | transloco"></app-textarea>
        <app-field-error controlName="description"></app-field-error>
      </div>
    </div>
    <div class="mt-3">
      <div>
        <app-input formControlName="contact"
                   [placeholder]="'popups.feedback.contacts' | transloco"></app-input>
        <app-field-error controlName="contact"></app-field-error>
      </div>
    </div>
    @if (isAuthenticated()) {
      <div class="mt-3">
        <p>{{ 'popups.feedback.images' | transloco }}</p>
        <app-file-uploader [files]="form.get('files')?.value" (uploadFile)="uploadFiles($event)"
                           (deleteFile)="deleteFiles($event)"></app-file-uploader>
      </div>
    }
  </form>
  <footer ngProjectAs="dialog-footer" class="flex gap-5">
    <app-button [title]="'popups.feedback.buttons.cancel' | transloco" variant="secondary"
                mat-dialog-close></app-button>
    <app-button [title]="'popups.feedback.buttons.confirm' | transloco" variant="primary" [disabled]="!form.valid"
                (click)="onSubmit()"></app-button>
  </footer>
</app-dialog>
